import * as React from "react";
import { Housing } from "../api/ApiClient";
import HowItWorksModal from "../signup/HowItWorksModal";
import PriceCalculator from "../signup/PriceCalculator";

class PriceEntry extends React.Component {
  private calculatorRef: React.RefObject<PriceCalculator> = React.createRef();

  render() {
    return (
      <div className="form-group">
        <label className="control-label mb-0">Hur bor du?</label>
        <PriceCalculator
          ref={this.calculatorRef}
          initArea={60}
          initConsumption={1980}
          initHousing={Housing.LAGENHET}
        />
        <button
          className="btn btn-primary btn-lg mt-4 mb-2"
          onClick={this.signup}>
          Gå vidare
        </button>
        <div className="text-center mt-2">
          <a href="#howItWorksModal" data-toggle="modal">
            Hur fungerar det?
          </a>
        </div>
        <HowItWorksModal />
      </div>
    );
  }

  signup = () => {
    let state = this.calculatorRef.current.getState();
    let housing =
      state && state.housing && state.housing.toString().length
        ? state.housing.toString().slice(0, 1)
        : "";
    console.debug("housing shortcut", housing);
    let location = `/bli-kund?c=${state.consumption}&h=${housing}&a=${state.area}`;
    window.location.assign(location);
  };
}

export default PriceEntry;
